export default __webpack_public_path__ + "static/media/trash.07e6c10f.svg";